module.exports = __webpack_public_path__ + "media/img/Landing_Page/s2u-cta-8c847470d4d5fc8dbb070623b7e67d0e.jpg";